import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {router} from 'lit-element-router';
import {msg} from '@lit/localize';
import store from '../store';

import getRoutes from '../routes';
import {loadConfigByShortNumber} from '../slices/shortNumberSlice';

@customElement('shortnumber-load')
export class ShortnumberLoad extends connect(store)(router(LitElement)) {

	static styles = [
		css`
			:host {
				display: flex;
			}

			.shortnumberLoad {
				width: 100%;
			}

			label {
				position: relative;
				display: block;
				cursor: pointer;
			}

			input {
				font-family: var(--font-family-monospace);
				font-size: var(--font-size-widget-small-mono);
				color: var(--color-widget-border-light);
				background-color: transparent;

				min-height: var(--height-widget);
				transition: background-color 0.4s, color 0.4s;
				padding: 0.5em 1em;
				line-height: 120%;
				margin: 0 0 var(--very-small-padding) 0;
				border: 1px solid var(--color-widget-border-light);
				width: 100%;
				box-sizing: border-box;
				text-align: left;
			}
		`
	];

	@property({type: Object})
	params = {};

	@property()
	shortNumber = '';

	static get routes() {
		return getRoutes();
	}

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	router(route, params, query, data) {
		this.params = params;
	}
	stateChanged(state) {
		this.dashboardActive = state.status.dashboardActive;
		this.specsheetActive = state.status.specsheetActive;
	}
	onShortNumber(e) {
		const num = e.target.value;
		if(e.key === 'Enter') {
			store.dispatch(loadConfigByShortNumber(
				{
					shortNumber: num,
				}
			));
		}
		this.requestUpdate();
	}

	render() {
		return html`
			<div class="shortnumberLoad">
				<div>${msg('load configuration number')}:</div>
				<label class="field-name">
					<div class="shortnumberLoad">
						<input type="text" name="shortNumber" id="shortNumber" .value=${this.shortNumber} @input=${this.onShortNumber}
							   @keypress=${this.onShortNumber}>
					</div>
				</label>

			</div>
		`;
	}
}
